import PropTypes from 'prop-types';
import React from 'react';
import { Card, CardBody } from 'reactstrap';

// Metric card component
const MetricCard = ({
  title,
  value: _value = null,
  subtitle: _subtitle = null,
  color: _color = null
}) => /*#__PURE__*/React.createElement(Card, {
  className: "h-100 border-0 shadow-sm"
}, /*#__PURE__*/React.createElement(CardBody, {
  className: "text-center py-2 px-1"
}, /*#__PURE__*/React.createElement("div", {
  className: "text-muted small mb-1"
}, title), /*#__PURE__*/React.createElement("div", {
  className: `h2 mb-0 ${_color ? `text-${_color}` : ''}`
}, _value !== null && _value !== void 0 ? _value : '—'), _subtitle && /*#__PURE__*/React.createElement("div", {
  className: "text-muted small mt-1"
}, _subtitle)));
MetricCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  subtitle: PropTypes.string,
  color: PropTypes.string
};

// Removed defaultProps - using default parameters in function signature instead

export default MetricCard;